import cx from 'classnames';
import Image, { ImageProps } from 'next/image';
import React, { AnchorHTMLAttributes, PropsWithChildren } from 'react';

import { IconArrowRight } from '../icons/ArrowRight';

import style from './InspirationLink.module.css';

type Props = PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>> & {
    image: ImageProps & {
        sizes: NonNullable<ImageProps['sizes']>;
    };
    href: string;
    obfuscate?: boolean;
};

export function InspirationLink({ className, children, image, obfuscate, ...props }: Props) {
    return (
        <a
            {...props}
            className={cx(
                'font-s-extrabold imageOverlay imageOverlayHoverDark text-shadow',
                style.inspirationLink,
                className,
            )}
            href={obfuscate ? undefined : props.href}
            onClick={(event) => {
                if (typeof props.onClick === 'function') {
                    props.onClick(event);
                }

                if (obfuscate) {
                    if (props.target === '_blank' || event.ctrlKey) {
                        return window.open(props.href, '_blank');
                    }
                    window.location.assign(props.href);
                }
            }}
        >
            <Image {...image} alt={image.alt} className={style.image} fill />
            <span className={style.text}>{children}</span>
            <IconArrowRight className={style.iconArrow} />
        </a>
    );
}
